import { Component, OnInit } from '@angular/core';
import {Helper} from '../../../app/utils/helper.module';

import { AuthService } from '../../core/auth/auth.service';
import { AccountService } from './account.service';
import {EventsService} from "../../bo/events/events.service";

// import '../../../assets/js/account.js'

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css'],
  providers: [AccountService],
})

export class AccountComponent implements OnInit {

  user: any;
  constructor(private authService: AuthService,private eventService: EventsService ) {
    this.user = authService.getUser();
    //console.log(authService.getUser())
    if(!authService.getUser().gender)
       this.user.gender = 0;

  }

  ngOnInit() {

    let $ = window['jQuery'];
    console.log(window.location.href)
    if(window.location.href.indexOf('tickets')>-1) {

      console.log('tickets in');
      $('#tab1').removeClass('active');
      $('#tab2').addClass('active');
      $('#monprofil-tab').removeClass('active');
      $('#mesbillets-tab').addClass('active');
    }
  }


  loadIp() {
    return this.eventService.getIp();
  }

  getInitials(string) {
    let names = string.split(' '),
      initials = names[0].substring(0,1).toUpperCase();

    if(names.length>1) {
      initials+= names[names.length-1].substring(0,1).toUpperCase();
    }

    return initials;
  }

}
